import { useSuspenseQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { homeApi } from "../api/home.api";
import { homeKeys } from "../constants/query-keys";

export function useOffers() {
  const { i18n } = useTranslation();
  return useSuspenseQuery({
    queryKey: homeKeys.data(i18n.language),
    queryFn: () => homeApi.get(i18n.language),
    select: (response) => ({ data: response.data.offers }),
  });
}
